<template>
  <div class="tab-contents">
    <SetupContents :bundle="bundle" :bundleContentOwnerships="contentOwnerships" />
  </div>
</template>

<script>
import Vue from 'vue';
import Component from 'vue-class-component';
import SetupContents from '../components/SetupContents';
import UIButton from '@/core/shared/components/ui/UIButton';

@Component({
  components: {
    SetupContents,
    UIButton,
  },
  props: {
    bundle: {
      type: Object,
      required: true,
    },
  },
  data: () => {
    return {
      bundleContentOwnerships: [],
    };
  },
})
export default class TabContentsRoute extends Vue {
  async created () {
    this.bundleContentOwnerships = await this.$store.dispatch('getContentOwnershipsForBundleCreation');
  }

  setBundle (bundle) {
    this.bundle = bundle;
  }

  get contentOwnerships () {
    return [...this.bundleContentOwnerships].sort((a, b) => {
      if (a.title < b.title) { return -1; }
      if (a.title > b.title) { return 1; }
      return 0;
    });
  }
}
</script>

<style lang="postcss" scoped>
@import "core/shared/styles";

.top {
  width: 100%;
  margin-bottom: var(--spacingMd);
  text-align: right;
}
</style>
